import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "content",
  id: "modal-content"
}
const _hoisted_2 = {
  class: "legacy-white-round-button",
  type: "button"
}
const _hoisted_3 = { class: "button-content" }
const _hoisted_4 = {
  key: 0,
  class: "header"
}
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_7 = { class: "golden-header legacy-text-button legacy-primary-button" }
const _hoisted_8 = { class: "button-content" }
const _hoisted_9 = { class: "modal-title" }
const _hoisted_10 = { class: "body" }
const _hoisted_11 = {
  key: 0,
  class: "image-wrapper"
}
const _hoisted_12 = { class: "body" }
const _hoisted_13 = {
  key: 0,
  class: "image-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_legacy_icon = _resolveComponent("legacy-icon")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", {'show': _ctx.show, 'hide-foreground': !_ctx.hasDarkForeground, [_ctx.backdropClass]: true}]),
    tabindex: "-1",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.checkClick($event)), ["stop"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog", _ctx.modalClasses + (_ctx.showModalCentered ? ' modal-dialog-centered': ' my-4') ]),
      style: _normalizeStyle(_ctx.modalStyles)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.hasCloseButton)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            }, [
              _createElementVNode("button", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_legacy_icon, {
                    class: "times close-icon",
                    icon: "times"
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content", {}, () => [
          (_ctx.hasHeader)
            ? _renderSlot(_ctx.$slots, "header", { key: 0 }, () => [
                (!_ctx.goldenTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.title), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.title), 1)
                        ])
                      ])
                    ]))
              ], true)
            : _createCommentVNode("", true),
          (_ctx.hasScrollBar)
            ? (_openBlock(), _createBlock(_component_perfect_scrollbar, {
                key: 1,
                style: _normalizeStyle({'max-height': _ctx.maxHeight})
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "body", {}, () => [
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.image)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", {
                              class: "img",
                              style: _normalizeStyle({'background-image': 'url('+_ctx.image+')'})
                            }, null, 4)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.description), 1)
                    ])
                  ], true)
                ]),
                _: 3
              }, 8, ["style"]))
            : _renderSlot(_ctx.$slots, "body", { key: 2 }, () => [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.image)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "img",
                          style: _normalizeStyle({'background-image': 'url('+_ctx.image+')'})
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.description), 1)
                ])
              ], true),
          (_ctx.hasFooter)
            ? _renderSlot(_ctx.$slots, "footer", { key: 3 }, () => [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "footer" }, null, -1))
              ], true)
            : _createCommentVNode("", true)
        ], true)
      ])
    ], 6)
  ], 2))
}